import {
  Grid2,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Snackbar,
  CircularProgress,
} from "@mui/material";
import styles from "./PointYourDomain.module.scss";
import CopyAllIcon from "@mui/icons-material/CopyAll";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useState } from "react";

export function PointYourDomain(props) {
  const {
    header,
    subHeader,
    preVer,
    rows,
    tableHeader,
    dnsVerified,
    dnsChecking,
  } = props;

  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const handleCopy = (text) => {
    navigator.clipboard.writeText(text);
    setSnackbarOpen(true);
  };

  return (
    <>
      <Grid2 className={styles.PointYourDomainContainer}>
        <Grid2 className={styles.PointYourDomain}>
          <Grid2 className={styles.text}>{header}</Grid2>
          <Grid2 className={styles.subText}>{subHeader}</Grid2>
        </Grid2>
        <Grid2>
          <TableContainer className={styles.main}>
            <Table>
              <TableHead className={styles.tableHead}>
                <TableRow className={styles.tablerow}>
                  {tableHeader?.map((header, index) => (
                    <TableCell
                      key={index}
                      className={styles.tableHeaderText}
                      align={index === 0 ? "left" : "center"}
                    >
                      {header}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {rows?.map((item, index) => (
                  <TableRow key={index}>
                    <TableCell className={styles.tableBodyText} align="left">
                      {item.recordName}
                    </TableCell>
                    <TableCell className={styles.tableBodyText} align="center">
                      {item.record}
                      <IconButton
                        onClick={() => handleCopy(item.record)}
                        className={styles.copyIcon}
                        size="small"
                      >
                        <CopyAllIcon fontSize="small" />
                      </IconButton>
                    </TableCell>
                    <TableCell className={styles.tableBodyText} align="center">
                      {item.ip}
                      <IconButton
                        onClick={() => handleCopy(item.ip)}
                        className={styles.copyIcon}
                        size="small"
                      >
                        <CopyAllIcon fontSize="small" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid2>
        {preVer && (
          <Grid2 className={styles.dnsStatus}>
            {dnsChecking ? (
              <>
                <CircularProgress size={14} className={styles.dnsChecking} />
                <Grid2 className={styles.dnsStatusText}>Checking DNS…</Grid2>
              </>
            ) : dnsVerified ? (
              <>
                <CheckCircleIcon className={styles.dnsVerifiedIcon} />
                <Grid2 className={styles.dnsVerifiedText}>DNS Verified</Grid2>
              </>
            ) : (
              <Grid2 className={styles.dnsWaitingText}>
                Waiting for the DNS records…
              </Grid2>
            )}
          </Grid2>
        )}
        {!preVer && (
          <Grid2 className={styles.subText}>
            Before traffic can go live, we need to verify your ownership of this
            domain. We will be able to do this automatically, after you have
            added the DNS details above, but this will cause some downtime. To
            avoid this downtime, you can add a TXT record before updating your
            DNS records.
          </Grid2>
        )}
      </Grid2>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={2000}
        onClose={() => setSnackbarOpen(false)}
        message="Value copied to clipboard"
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      />
    </>
  );
}
